import { IActionFn } from '@/store/types';
import { IModuleState } from './types';
import { $asset } from '@/axios';

// 查询当前导航树
export const queryDigitalRoomNav: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDigitalRoomNav', { ...state.navigationTree, loading: true });
    const res = await $asset('static', '/mock/navigation.json');
    commit('setDigitalRoomNav', { data: res });
  } catch (e) {
    commit('setDigitalRoomNav', { data: [] });
  }
};

